export default {
  data: () => ({
    data: [],
    totalRows: 1,
    currentPage: 1,
    perPage: 50,
    pageOptions: [2, 25, 50, 100, 'All'],
    itemsPerPage: 50,
    sortBy: '',
    sortDesc: false,
    sortDirection: 'asc',
    filter: null,
    filterOn: []
  }),

  computed: {
    minPerPage () {
      return this.pageOptions[0]
    }
  },
  watch: {
    perPage (newVal, oldVal) {
      if (newVal !== oldVal) this.currentPage = 1
    }
  }
}
